import * as React from 'react';
import { sortBasedOnList } from '../utils';

export interface ITable2ClassProps {
  data: Table2Data;
}

interface ITable2State {
}

const initialState: ITable2State = {
};

export type Table2Data = { [key: string]: Table2Row };

type Table2Row = {
  crashesTotal: number;
  crashesChangeTotal: number;
  crashesFatal: number;
  nonFatalCrashesTotal: number;
  nonFatalCrashesInjuryA: number;
  nonFatalCrashesInjuryB: number;
  nonFatalCrashesInjuryC: number;
  crashesPdo: number;
  personsFatal: number;
  personsChangeFatal: number;
  personsInjuryA: number;
  personsNonFatalTotal: number;
  personsChangeInjuryA: number;
  personsChangeNonFatal: number;
}

const sortOrder = [
  "Pedestrian",
  "Motor vehicle in transport",
  "Parked motor vehicle",
  "Railroad train",
  "Pedalcyclist",
  "Animal",
  "Fixed object",
  "Other object",
  "Non-collision overturned",
  "Other non-collision",
  "Unknown",
  "TOTALS",
]

export default class Table2 extends React.Component<ITable2ClassProps, ITable2State> {
  public constructor(props: any) {
    super(props);
    this.state = initialState;
  };

  public render() {
    return (
      <React.Fragment>
        {!this.props.data && (
          <p>Loading....</p>
        )}
        {this.props.data && (
          <table className="ss-table summaryTable1">
            <thead>
              <tr>
                <th rowSpan={3} colSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number" style={{ border: 'none' }}>2</span>
                    <div style={{ width: '3px', height: '80px', backgroundColor: 'black' }} />
                    <span className="header-text" style={{ fontSize: '14px' }}>
                      FIRST HARMFUL EVENT
                      <br />
                      <span style={{ fontSize: '13px' }}>(PREVIOUS YEAR)</span>
                    </span>
                  </div>
                </th>
                <th colSpan={8} className="border-right-bold">CRASHES</th>
                <th colSpan={6} className="border-right-bold">PERSONS KILLED OR INJURED</th>
              </tr>
              <tr>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>% CHG TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={4}>NON-FATAL INJURY CRASHES</th>
                <th rowSpan={2} className="border-right-bold">PDO **</th>
                <th rowSpan={2}>KILLED</th>
                <th rowSpan={2}>% CHG KILLED</th>
                <th colSpan={2}>NON-FATAL INJURIES</th>
                <th rowSpan={2}>% CHG A*</th>
                <th rowSpan={2}>% CHG TOTAL</th>
              </tr>
              <tr>
                <th>TOTAL</th>
                <th>A *</th>
                <th>B * </th>
                <th>C * </th>
                <th>A *</th>
                <th>TOTAL</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key, index) =>
                <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                  {index === 0 &&
                    <td rowSpan={8}><p className="verticalColumn" style={{ width: 17, left: 0 }}>Collision Involving</p></td>
                  }
                  <td colSpan={index > 7 ? 2 : 1} className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].crashesTotal}</td>
                  <td className="numberTotals">{this.props.data[key].crashesChangeTotal}</td>
                  <td className="numberTotals">{this.props.data[key].crashesFatal}</td>
                  <td className="numberTotals">{this.props.data[key].nonFatalCrashesTotal}</td>
                  <td className="numberTotals">{this.props.data[key].nonFatalCrashesInjuryA}</td>
                  <td className="numberTotals">{this.props.data[key].nonFatalCrashesInjuryB}</td>
                  <td className="numberTotals">{this.props.data[key].nonFatalCrashesInjuryC}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].crashesPdo}</td>
                  <td className="numberTotals">{this.props.data[key].personsFatal}</td>
                  <td className="numberTotals">{this.props.data[key].personsChangeFatal}</td>
                  <td className="numberTotals">{this.props.data[key].personsInjuryA}</td>
                  <td className="numberTotals">{this.props.data[key].personsNonFatalTotal}</td>
                  <td className="numberTotals">{this.props.data[key].personsChangeInjuryA}</td>
                  <td className="numberTotals">{this.props.data[key].personsChangeNonFatal}</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </React.Fragment>
    );
  }
}
